import React, { Suspense } from 'react';

import { App as CVTApp } from '@cvt/App';

import { AuthProvider } from '@modules/Auth/contexts';
import { UserProvider } from '@modules/Users/contexts';
import { CompanyProvider } from '@modules/Companies/contexts';

import { MainLayout } from '@shared/components/layouts/MainLayout';
import { Dialogs } from '@shared/components/Dialogs';

import { Root } from '@pages/Root';
import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';


const App = () => {
  return (
    <CVTApp>
      <ErrorBoundary>
        <Suspense fallback={<BodyLoading height="100vh"/>}>
          <AuthProvider>
            <UserProvider>
              <CompanyProvider>
                <MainLayout>
                  <Root/>
                  <Dialogs/>
                </MainLayout>
              </CompanyProvider>
            </UserProvider>
          </AuthProvider>
        </Suspense>
      </ErrorBoundary>
    </CVTApp>
  );
};

export default App;
